// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource' //添加vue-resource的依赖
import routes from './router/router'
import {routerMode} from './util/env'
import './util/rem'
import FastClick from 'fastclick'
import store from './store/'

if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function() {
        FastClick.attach(document.body);
    }, false);
}

Vue.use(VueRouter);//为Vue添加vue-router
Vue.use(VueResource);//为Vue添加vue-resource
Vue.http.options.emulateHTTP = true;
Vue.http.options.emulateJSON = true;

Vue.http.options.headers = {
    'Content-Type': 'application/json;charset=UTF-8'
}
const router = new VueRouter({
    routes,
    mode: routerMode,
	strict: process.env.NODE_ENV !== 'production',
});

router.beforeEach((to, from, next) => {
	document.body.scrollTop = document.documentElement.scrollTop = 0;
	next();
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js